// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrapper":"styles_buttonsWrapper__2jD5K","notificationTooltip":"styles_notificationTooltip__3HRkh"};